import { render, staticRenderFns } from "./FormImportarEmendas.vue?vue&type=template&id=5661d0e5"
import script from "./FormImportarEmendas.vue?vue&type=script&lang=js"
export * from "./FormImportarEmendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports